import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { User } from '../models/group';
import { UserService } from './user.service';

@Injectable()
export class UserResolver implements Resolve<User> {
  constructor(private userService: UserService) {}

  resolve() {
    let userRef =  this.userService.getCurrentUser();
    return new Promise<User>((resolve, reject) => {
      userRef.snapshotChanges().subscribe(res => {
        var payload = res.payload.val();
        payload.id = res.key;
        resolve(new User(payload));
      }, reject)
    })
  }
}